import { Qualifier } from './Qualifier';
import { IQualifier } from './IQualifier';
import DebitPosTransactionTypes from '../DebitPosTransactionTypes';

export class PosQualifier extends Qualifier {
    public static readonly CLASS: string = 'com.bancvue.rcx.config.product.qualifiers.api.PosQualifier';

    public static readonly NAME: string = 'POS Transactions';

    transactionType: string = DebitPosTransactionTypes.ALL;

    minimumTransactionCount: number = 0;

    minimumTransactionAmount: number = 0;

    constructor(qual?: IQualifier) {
      super(PosQualifier.CLASS, qual ? qual.id : null);

      if (qual) {
        this.transactionType = (qual as any).transactionType;
        this.minimumTransactionCount = (qual as any).minimumTransactionCount;
        this.minimumTransactionAmount = (qual as any).minimumTransactionAmount;
      }
    }

    getDescription(): string {
      return `${this.minimumTransactionCount} POS transaction(s)`;
    }

    clone(): IQualifier {
      const clone = new PosQualifier();
      Object.assign(clone, this);
      return clone;
    }
}

export default PosQualifier;
